import { CurrentUserI } from '../api/users/interfaces/Users';

/**
 * Nombre de la empresa del usuario logueado.
 *
 * Sale de `currentUser.company`, que el backend resuelve desde `companies` vía
 * `users.company_id`. Sustituye a `currentUser.user.companyName`, que era una
 * copia congelada en el alta: 44% del parque tenía ahí el nombre viejo de su
 * empresa y con él se pintaban pantallas, emails e informes.
 *
 * @param currentUser respuesta de `GET /users/current-user`
 * @param fallback texto a mostrar cuando el usuario no tiene empresa
 *   (B2C / autónomo puro). Por defecto, cadena vacía.
 */
export const resolveCompanyName = (
	currentUser: CurrentUserI | null | undefined,
	fallback = ''
): string => currentUser?.company?.name || fallback;
